export default __webpack_public_path__ + "static/customFilter-dfffac33c0191bfedbd1584e3c34a058.gif";